<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 16"
    fill="none"
  >
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M8.7 9.99999C8.7 10.3866 8.3866 10.7 8 10.7C7.6134 10.7 7.3 10.3866 7.3 9.99999V3.68981L5.16148 5.82834C4.88811 6.1017 4.4449 6.1017 4.17153 5.82834C3.89816 5.55497 3.89816 5.11175 4.17153 4.83839L7.50487 1.50505C7.57802 1.4319 7.66334 1.37832 7.75431 1.34432C7.83075 1.31566 7.91355 1.29999 8 1.29999C8.19844 1.29999 8.37759 1.38256 8.50497 1.51521L11.8281 4.83839C12.1015 5.11175 12.1015 5.55497 11.8281 5.82834C11.5548 6.1017 11.1116 6.1017 10.8382 5.82834L8.7 3.69014V9.99999ZM2 9.29999C2.3866 9.29999 2.7 9.61339 2.7 9.99999V12.6667C2.7 12.8346 2.76673 12.9957 2.8855 13.1145C3.00428 13.2333 3.16537 13.3 3.33334 13.3H12.6667C12.8346 13.3 12.9957 13.2333 13.1145 13.1145C13.2333 12.9957 13.3 12.8346 13.3 12.6667V9.99999C13.3 9.61339 13.6134 9.29999 14 9.29999C14.3866 9.29999 14.7 9.61339 14.7 9.99999V12.6667C14.7 13.2059 14.4858 13.7231 14.1045 14.1044C13.7231 14.4858 13.2059 14.7 12.6667 14.7H3.33334C2.79406 14.7 2.27688 14.4858 1.89555 14.1044C1.51423 13.7231 1.3 13.2059 1.3 12.6667V9.99999C1.3 9.61339 1.6134 9.29999 2 9.29999Z"
      fill="currentColor"
    />
  </svg>
</template>
